import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { DocumentLibraryService } from '@dealstack/frontend/shared/dataExchange/services/document-library/document-library.service';
import { GetDocumentRes } from '@dealstack/shared/lib/generated';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';

interface Options
	extends Omit<
		UseQueryOptions<ApiV1.Response<GetDocumentRes>, unknown, GetDocumentRes, [string]>,
		'queryKey' | 'queryFn'
	> {
	dealId: string;
	selectedDocumentId: string;
}

export const useGetDocument = (options: Options) => {
	const { dealId, selectedDocumentId, ...queryOptions } = options;

	return useQuery({
		queryKey: [
			formatUnicorn(API_PATHS.DEAL_DEALID_DOCUMENT_LIBRARY_DOCUMENT_DOCUMENTID_GET, {
				dealId,
				documentId: selectedDocumentId,
			}),
		],
		queryFn: ({ signal }) =>
			DocumentLibraryService.getDocument(
				formatUnicorn(API_PATHS.DEAL_DEALID_DOCUMENT_LIBRARY_DOCUMENT_DOCUMENTID_GET, {
					dealId,
					documentId: selectedDocumentId,
				}),
				undefined,
				signal
			),
		enabled: Boolean(dealId && selectedDocumentId),
		select: (data) => data.payload,
		...queryOptions,
	});
};
